import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import "./image-view.css"



const regexToFindClases = /st[0-9]+/g
const regexToFindIDS = /SVGID/g

const replaceClasses = (assetId) => {
  const assetIdToUse = (assetId) ? assetId : ""

  return (match) => {

    return match + "_" + assetIdToUse

  }

}

const replaceIds = assetId => {
  const assetIdToUse = (assetId) ? assetId : ""

  return (match) => {

    return match + "_" + assetIdToUse

  }
}

export class SVGView extends Component {

  _isMounted = false;

  constructor(props) {
    super(props)

    this.state = {
      svg: null
    }
  }

  componentDidMount() {
    this._isMounted = true;
    const { assetId } = this.props
    fetch(this.props.src)
      .then(res => res.text())
      .then(text => text.replace(regexToFindClases, replaceClasses(assetId)))
      .then(text => text.replace(regexToFindIDS, replaceIds(assetId)))
      .then(text => {
        if(this._isMounted){
          this.setState({ svg: text })
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { svg } = this.state
    const { comFromMiddleView, comeFromNewListComments } = this.props
    const svgClasses = classNames('', {
      'img-svg-asset-middleview': comFromMiddleView,
      'img-svg-asset-last-comment': comeFromNewListComments,
      'img-svg-asset': !comFromMiddleView && !comeFromNewListComments,


    })
    return <div className={svgClasses} dangerouslySetInnerHTML={{ __html: svg }} />
    // return <div className={comFromMiddleView ? "img-svg-asset-middleview" : "img-svg-asset"} dangerouslySetInnerHTML={{ __html: svg }} />
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(SVGView)))
